import client from '@libs/HttpClient';

class SkillsScoringOptionsService {
  // List Skills Scoring Options
  static listSkillsScoringOptions({ page = 1, searchText = '', status = '', skillId = '' }) {
    return client.get('/skills-scoring-options', {
      params: {
        page,
        option_name: searchText,
        option_status: status,
        skill_scoring_parameters_id: skillId,
      },
    });
  }

  // View a single Skills Scoring Option
  static viewSkillsScoringOption(id) {
    return client.get(`/skills-scoring-options/${id}`);
  }

  // Add new Skills Scoring Option
  static addSkillsScoringOption(request) {
    return client.post('/skills-scoring-options', request);
  }

  // Update existing Skills Scoring Option
  static updateSkillsScoringOption(request) {
    return client.put(`/skills-scoring-options/${request.id}`, request);
  }

  // Delete a Skills Scoring Option
  static deleteSkillsScoringOption(request) {
    return client.delete(`/skills-scoring-options/${request.id}`, request);
  }

  static statusChangeSkillsScoringOption(request) {
    return client.patch(
      `/skills-scoring-options/change-status/${request.id}`,
      { option_status: request.option_status } // only the DB column
    );
  }
}

export { SkillsScoringOptionsService };